type LogLevel = "debug" | "info" | "warn" | "error";

const levelStyles: Record<LogLevel, string> = {
  debug:
    "background: #4CAF50; color: white; font-weight: bold; padding: 2px 6px; border-radius: 4px;",
  info: "background: #2196F3; color: white; font-weight: bold; padding: 2px 6px; border-radius: 4px;",
  warn: "background: #FFC107; color: black; font-weight: bold; padding: 2px 6px; border-radius: 4px;",
  error:
    "background: #F44336; color: white; font-weight: bold; padding: 2px 6px; border-radius: 4px;",
};

export const Logger = {
  debug(label: string, data?: unknown) {
    console.log(`%c${label}`, levelStyles.debug, data ?? "");
  },

  info(label: string, data?: unknown) {
    console.log(`%c${label}`, levelStyles.info, data ?? "");
  },

  warn(label: string, data?: unknown) {
    console.warn(`%c${label}`, levelStyles.warn, data ?? "");
  },

  error(label: string, data?: unknown) {
    console.error(`%c${label}`, levelStyles.error, data ?? "");
  },
} as const;
